import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-54cd2bf4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "d-photos-header"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "d-photos-header__title" }, "My Cases", -1))
const _hoisted_3 = { class: "d-layout-switcher" }
const _hoisted_4 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_item_case = _resolveComponent("item-case")!
  const _component_app_skeleton_case = _resolveComponent("app-skeleton-case")!
  const _component_app_no_message = _resolveComponent("app-no-message")!
  const _component_refresh_pull = _resolveComponent("refresh-pull")!

  return (_openBlock(), _createElementBlock("div", null, [
    (!_ctx.mainStore.isMobile)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("span", {
              class: _normalizeClass(["d-layout-switcher__btn icon", !_ctx.driveStore.isGridCasesView ? 'active icon-list-view-2-active' : 'icon-list-view-2']),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.driveStore.isGridCasesView = false))
            }, null, 2),
            _createElementVNode("span", {
              class: _normalizeClass(["d-layout-switcher__btn icon", _ctx.driveStore.isGridCasesView ? 'active icon-tiles-2-active' : 'icon-tiles-2']),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.driveStore.isGridCasesView = true))
            }, null, 2)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.mainStore.isMobile)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "scroll",
          onScroll: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleScroll && _ctx.handleScroll(...args))),
          ref: "scroller"
        }, [
          _createVNode(_component_refresh_pull, {
            modelValue: _ctx.loadingPull,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.loadingPull) = $event)),
            onRefresh: _ctx.onRefresh,
            successText: _ctx.successText,
            pullingText: _ctx.pullingText,
            loosingText: _ctx.loosingText,
            loadingText: _ctx.loadingText,
            disabled: !!_ctx.driveStore.search || _ctx.isPageLoading
          }, {
            default: _withCtx(() => [
              (_ctx.cases.length || _ctx.dataLoading)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(["case-wrapper", {'case-wrapper--column': !_ctx.driveStore.isGridCasesView}])
                  }, [
                    (!_ctx.dataLoading)
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.cases, (iCase) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: iCase.id!,
                            class: "case"
                          }, [
                            _createVNode(_component_item_case, {
                              iCase: iCase,
                              columnView: !_ctx.driveStore.isGridCasesView,
                              selector: _ctx.driveStore.isCaseSelector,
                              onOpenCase: ($event: any) => (_ctx.onCaseClick(iCase))
                            }, null, 8, ["iCase", "columnView", "selector", "onOpenCase"])
                          ]))
                        }), 128))
                      : _createCommentVNode("", true),
                    (_ctx.dataLoading || _ctx.isPageLoading)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, _renderList(9, (n) => {
                          return _createElementVNode("div", {
                            class: "case",
                            key: n
                          }, [
                            _createVNode(_component_app_skeleton_case, {
                              columnView: !_ctx.driveStore.isGridCasesView
                            }, null, 8, ["columnView"])
                          ])
                        }), 64))
                      : _createCommentVNode("", true)
                  ], 2))
                : _createCommentVNode("", true),
              (_ctx.noCasesMessage)
                ? (_openBlock(), _createBlock(_component_app_no_message, {
                    key: 1,
                    icon: _ctx.noCasesMessage.icon
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.noCasesMessage.text), 1)
                    ]),
                    _: 1
                  }, 8, ["icon"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["modelValue", "onRefresh", "successText", "pullingText", "loosingText", "loadingText", "disabled"])
        ], 544))
      : (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: "scroll",
          onScroll: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.handleScroll && _ctx.handleScroll(...args))),
          ref: "scroller"
        }, [
          (_ctx.cases.length || _ctx.dataLoading)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["case-wrapper", {'case-wrapper--column': !_ctx.driveStore.isGridCasesView}])
              }, [
                (!_ctx.dataLoading)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.cases, (iCase) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: iCase.id!,
                        class: "case",
                        onClick: ($event: any) => (_ctx.onCaseClick(iCase))
                      }, [
                        _createVNode(_component_item_case, {
                          iCase: iCase,
                          columnView: !_ctx.driveStore.isGridCasesView,
                          selector: _ctx.driveStore.isCaseSelector
                        }, null, 8, ["iCase", "columnView", "selector"])
                      ], 8, _hoisted_4))
                    }), 128))
                  : _createCommentVNode("", true),
                (_ctx.dataLoading || _ctx.isPageLoading)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, _renderList(9, (n) => {
                      return _createElementVNode("div", {
                        class: "case",
                        key: n
                      }, [
                        _createVNode(_component_app_skeleton_case, {
                          columnView: !_ctx.driveStore.isGridCasesView
                        }, null, 8, ["columnView"])
                      ])
                    }), 64))
                  : _createCommentVNode("", true)
              ], 2))
            : _createCommentVNode("", true),
          _withDirectives(_createVNode(_component_app_no_message, {
            icon: _ctx.noCasesMessage.icon
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.noCasesMessage.text), 1)
            ]),
            _: 1
          }, 8, ["icon"]), [
            [_vShow, !_ctx.dataLoading && _ctx.noCasesMessage && !_ctx.driveStore.cases.data]
          ])
        ], 544))
  ]))
}